export default "__VITE_ASSET__71bba311__"